"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Checkbox as CheckboxPrimitive } from "radix-ui";
import { cn } from "@/lib/utils";

// Чекбокс по макету (компонент `checkbox`): 20×20, пустой — обводка #1F1F1F 24 %
// 1px, отмеченный — заливка #FF5E00 с белой галочкой. Скругление r5 (фильтры,
// формы) или r8 — `shape="round"` (корзина, «Выбрать все», идея).
function Checkbox(t0) {
  const $ = _c(13);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      shape: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const shape = t1 === undefined ? "square" : t1;
  const t2 = shape === "round" ? "rounded-[8px]" : "rounded-[5px]";
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn("peer grid size-5 shrink-0 cursor-pointer place-content-center border border-ds-primary/24 bg-white text-white transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ds-focus focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-ds-error data-[state=checked]:border-ds-check data-[state=checked]:bg-ds-check data-[state=indeterminate]:border-ds-check data-[state=indeterminate]:bg-ds-check", t2, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props.checked) {
    t4 = <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="grid place-content-center text-current">{props.checked === "indeterminate" ? <svg viewBox="0 0 12 12" className="size-3" aria-hidden="true"><path d="M2.5 6h7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg> : <svg viewBox="0 0 12 12" className="size-3" fill="none" aria-hidden="true"><path d="M2.25 6.25 4.75 8.75 9.75 3.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>}</CheckboxPrimitive.Indicator>;
    $[7] = props.checked;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props || $[10] !== t3 || $[11] !== t4) {
    t5 = <CheckboxPrimitive.Root data-slot="checkbox" className={t3} {...props}>{t4}</CheckboxPrimitive.Root>;
    $[9] = props;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export { Checkbox };